import { Text } from "agrofy-ui-components";
import React, { useState, useEffect } from "react";
import { useStore } from "../../hooks/store";
import "./AgrofyPaymentMethodsPrincipal.scss";
import { useTranslation } from "react-i18next";
import PaymentMethodsMenu from "../../molecules/AgrofyPaymentMethods/PaymentMethodsMenu/PaymentMethodsMenu";
import PaymentMethodsBody from "../../molecules/AgrofyPaymentMethods/PaymentMethodsBody/PaymentMethodsBody";

const AgrofyPaymentMethodsPrincipal = (props) => {
  const state = useStore()[0];
  const { t } = useTranslation();
  const [hasSelectedPaymentMethod, setHasSeletectedPaymentMethod] =
    useState(false);

  useEffect(() => {
    setHasSeletectedPaymentMethod(!!state.selectedPaymentMethodType);
  }, [state.selectedPaymentMethodType]);

  const mobileStructure = (
    <span className="d-mobile">
      {!hasSelectedPaymentMethod ? (
        <div className={"sideContainer"}>
          <PaymentMethodsMenu />
        </div>
      ) : (
        <div className={"principalContainer"}>
          <PaymentMethodsBody />
        </div>
      )}
    </span>
  );

  const desktopStructure = (
    <span className="d-desktop d-flex">
      <div className={"sideContainer"}>
        <PaymentMethodsMenu />
      </div>
      <div className={"principalContainer"}>
        <PaymentMethodsBody />
      </div>
    </span>
  );

  return (
    <section>
      <div
        className={[
          hasSelectedPaymentMethod ? "d-desktop" : null,
          "titleContainer",
        ].join(" ")}
      >
        <div>
          <Text type="heading-sm" className="heading-xl" weight="500" tag="h1" ma="0">
            {t("payment_data_title")}
          </Text>
        </div>
      </div>

      <div
        className={[
          hasSelectedPaymentMethod ? "bg-white" : null,
          "bodyContainer body",
        ].join(" ")}
      >
        {mobileStructure} 
        {desktopStructure}
      </div>
    </section>
  );
};

export default AgrofyPaymentMethodsPrincipal;
